const Interest = Object.freeze({
  AU: 'AU',
  BE: 'BE',
  LI: 'LI',
  AN: 'AN',
  FA: 'FA',
  FS: 'FS',
  AC: 'AC',
  FD: 'FD',
  GA: 'GA',
  GL: 'GL',
  HF: 'HF',
  HG: 'HG',
  MO: 'MO',
  MU: 'MU',
  OU: 'OU',
  PE: 'PE',
  PV: 'PV',
  PO: 'PO',
  RE: 'RE',
  SH: 'SH',
  SP: 'SP',
  TV: 'TV',
  TE: 'TE',
  TR: 'TR'
})
export default Interest
export type InterestStrings = typeof Interest[keyof typeof Interest]
// RESERVE BELOW
